/** Stable React list keys from CMS items (fallback only when content is empty). */
export function buttonKey(button, index) {
  const label = button?.label?.trim();
  const link = button?.link?.trim();
  if (label && link) return `${label}::${link}`;
  if (label) return label;
  if (link) return link;
  return `button-${index}`;
}

export function textKey(text, index) {
  const value = typeof text === "string" ? text.trim() : "";
  if (value) return value;
  return `text-${index}`;
}
